var map = {
	"./loader.glb": 2621,
	"./men/animations/package.glb": 2727,
	"./men/base.glb": 5062,
	"./men/styles/hair/type_1.glb": 3544,
	"./men/styles/hair/type_2.glb": 6760,
	"./men/styles/hair/type_3.glb": 7990,
	"./men/styles/pant/type_1.glb": 2534,
	"./men/styles/pant/type_2.glb": 2843,
	"./men/styles/pant/type_3.glb": 2729,
	"./men/styles/pant/type_4.glb": 4854,
	"./men/styles/pant/type_5.glb": 4623,
	"./men/styles/pant/type_6.glb": 9684,
	"./men/styles/shirt/type_1.glb": 2444,
	"./men/styles/shirt/type_10.glb": 101,
	"./men/styles/shirt/type_2.glb": 3260,
	"./men/styles/shirt/type_3.glb": 1913,
	"./men/styles/shirt/type_4.glb": 2950,
	"./men/styles/shirt/type_5.glb": 3737,
	"./men/styles/shirt/type_6.glb": 4512,
	"./men/styles/shirt/type_7.glb": 1231,
	"./men/styles/shirt/type_8.glb": 2391,
	"./men/styles/shirt/type_9.glb": 9008,
	"./men/styles/shoe/type_1.glb": 7894,
	"./men/styles/shoe/type_2.glb": 4369,
	"./stage.glb": 2103,
	"./stage_glow.glb": 3770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2854;